import {view} from '@sail/ui';
import {useIntl} from '@sail/intl';
import React from 'react';
import {GelatoVerificationIframe, LoadingState} from '../../SharedComponents';

type Props = {
  verificationSession: string;
  onCompleted: () => void;
  onError: (error: Error) => void;
  overrideBranding?: boolean;
};

export const IdentityVerification = ({
  verificationSession,
  onCompleted,
  onError,
  overrideBranding,
}: Props) => {
  const intl = useIntl();
  const [completed, setCompleted] = React.useState(false);
  const {locale} = intl;

  const url = new URL(verificationSession);

  if (locale) {
    url.searchParams.append('locale', locale);
  }

  if (overrideBranding) {
    url.searchParams.append('overrideBranding', 'true');
  }

  return (
    <view.div
      css={{
        stack: 'x',
        textAlign: 'center',
        alignX: 'center',
        padding: 'space.0',
      }}
    >
      <GelatoVerificationIframe
        css={{
          padding: 'space.0',
        }}
        loadingComponent={<LoadingState />}
        frameBorder="0"
        verificationLink={url.href}
        onError={() => onError(new Error('Identity session error'))}
        onSuccess={() => {
          // gets called multiple times, so we need to check if we've already completed
          if (!completed) {
            setCompleted(true);
            onCompleted();
          }
        }}
        onTimeout={() => onError(new Error('Identity session error'))}
        onMount={() => {}}
        onLoad={() => {}}
      />
    </view.div>
  );
};
